module.exports = __webpack_public_path__ + "img/08_lawless-capture.4959980b.jpg";